/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { ViewChild, ElementRef, Renderer2, RendererFactory2, Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { IcepanelComponent } from './icepanel.component';
import { IcepanelService } from './icepanel.service';
import { Iceutility } from '../../services/iceutility';

@Component({
  selector: 'icecontrol',
  templateUrl: './icecontrol.component.html',
  styleUrls: ['./icepanelcontainer.component.scss'],
  providers: [IcepanelService]
})
export class IcecontrolComponent implements OnInit {
    @Input() type: string = "";
    @Input() display: string = "";
    @Input() properties: any = {};
	@Input() events: any = {};
    @Input() field: string = "";
    @Input() controlId: string = "";
    @Input() editMode: boolean = false;
    @Input() value: string = "";

	private lastValue: any = null;
    private baseControl: any = null;

  constructor(private targetRef: ElementRef, 
    @Inject(IcepanelComponent) private parent: IcepanelComponent,
    private panelSvc: IcepanelService, 
    private rendererFactory: RendererFactory2) { 
  }

  ngOnInit() {
	this.renderControl();
  }
  
  renderControl(){
      let parentElm: HTMLElement = document.getElementById(this.parent.controlId);
      let renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);
      this.panelSvc.addControl(renderer, this, parentElm, parentElm);
  }
}

@Component({
    selector: 'iceheadercontrol',
    templateUrl: './icecontrol.component.html',
    styleUrls: ['./icepanelcontainer.component.scss'],
	  providers: [IcepanelService]
})
export class IceheadercontrolComponent extends IcecontrolComponent implements OnInit {
    ngOnInit() {
	  this.renderControl();
    }
}
